import { Draggable } from "@hello-pangea/dnd";
import { ArrowDropDown, Edit } from "@mui/icons-material";
import { Chip, IconButton, InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import ActionChips from "./ActionChips";
import ConditionChips from "./ConditionChips";
import { chipColors } from "./constants";

const StyledRuleContainer = styled("div")({
    border: "0.5px solid #c0c0c0",
    borderRadius: "5px",
    margin: "2px 0px",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
});

const StyledRuleNameContainer = styled("div")({
    display: "flex",
    alignItems: "center",
});

const StyledArrowDropDown = styled(ArrowDropDown)({
    display: "flex",
    alignItems: "center",
    color: "#9E9E9E",
    transition: "transform 0.4s ease-in-out",
});

const StyledLabel = styled("span")({
    fontSize: "12px",
});

const StyledPriorityAndEditContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
});

const StyledChip = styled(Chip)(() => ({
    marginBottom: "5px",
    border: `0.1em solid ${chipColors.hidden}`,
}));

const ComplianceRule = (props) => {
    const { rule, editRule, index } = props;

    const [isExpanded, setIsExpanded] = useState(false);
    const { ruleName, priority, ruleKey, initialPriority } = rule;
    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: "none",
        // change background colour if dragging
        background: isDragging ? "#C5C5C5" : "",
        borderRadius: "5px",
        // styles we need to apply on draggables
        ...draggableStyle,
    });

    return (
        <React.Fragment>
            <Draggable draggableId={`Document Compliance Draggable - ${String(index)}`} index={index}>
                {(provided, snapshot) => {
                    return (
                        <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
                        >
                            <StyledRuleContainer>
                                <div>
                                    <StyledRuleNameContainer onClick={() => setIsExpanded(!isExpanded)}>
                                        <div>
                                            <InputLabel shrink>{ruleName}</InputLabel>
                                        </div>
                                        <div>
                                            <StyledArrowDropDown
                                                style={{ transform: !isExpanded ? null : "rotate(180deg)" }}
                                            />
                                        </div>
                                    </StyledRuleNameContainer>
                                    <div>
                                        <div>
                                            <StyledLabel>Actions</StyledLabel>
                                        </div>
                                        <div style={{ flexWrap: !isExpanded ? "nowrap" : "wrap" }}>
                                            <ActionChips rule={rule} noWrap={!isExpanded} showDocName={true} />
                                        </div>
                                        <div>
                                            <StyledLabel>Conditions</StyledLabel>
                                            <div style={{ flexWrap: !isExpanded ? "nowrap" : "wrap" }}>
                                                <ConditionChips rule={rule} noWrap={!isExpanded} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <StyledPriorityAndEditContainer>
                                    <div style={{ flex: "1 1 auto" }}>
                                        <InputLabel shrink>{"Priority"}</InputLabel>
                                    </div>
                                    <div style={{ flex: "1 1 auto" }}>
                                        <span style={{ padding: "10px" }}>
                                            <StyledChip
                                                variant="outlined"
                                                label={priority}
                                                style={
                                                    initialPriority !== priority
                                                        ? { border: `0.2em solid ${chipColors.optional}` }
                                                        : {}
                                                }
                                            />
                                        </span>
                                    </div>
                                    <div style={{ flex: "1 1 auto" }}>
                                        <IconButton data-testid="editRule" onClick={() => editRule(ruleKey)}>
                                            {<Edit />}
                                        </IconButton>
                                    </div>
                                </StyledPriorityAndEditContainer>
                            </StyledRuleContainer>
                        </div>
                    );
                }}
            </Draggable>
        </React.Fragment>
    );
};

export default ComplianceRule;
